import clsx from "clsx";

import React from "react";

interface TextFieldProps extends React.HTMLProps<HTMLInputElement> {
  fullWidth?: boolean;
  small?: boolean;
  label?: string;
}

export const TextField = React.forwardRef<any, TextFieldProps>(
  (
    { fullWidth = false, className, small = false, label, disabled, ...rest },
    ref
  ) => {
    return (
      <div className="flex flex-col space-y-1">
        {label && (
          <label className="text-sm text-black font-medium opacity-80">
            {label}
          </label>
        )}
        <input
          className={clsx(
            "rounded border outline-none focus:drop-shadow-none focus:ring-2 !border-orange-600 focus:ring-orange-600",
            fullWidth && "w-full",
            disabled
              ? "bg-gray-200 text-gray-800 cursor-not-allowed"
              : "bg-white text-black ",
            small ? "px-1 py-0.5" : "px-3 py-2",
            className
          )}
          disabled={disabled}
          ref={ref}
          {...rest}
        />
      </div>
    );
  }
);
